import { FETCH_DELIVERABLES } from "../actions/deliverable";
import { FormatDateUK } from "../helpers";

export const StatusValidation = (item, dependencies) => {
    let _allCompleted = true;

    if (!dependencies || dependencies.length === 0) return true;

    dependencies.map((dept, index) => {
        if (dept.children.findIndex(x => x == item.key) !== -1) {

            if (dept.status !== 'completed') {

                _allCompleted = false;

            }

        }
    });

    return _allCompleted;
}
export const DeliverableValidation = (item, objectives) => {
    let messages = [];

    if (item.name === '') {
        messages.push("Please enter a title");
    }

    if (item.description === '') {
        messages.push("Please enter a description");
    }

    if (item.users.length === 0) {
        messages.push("Please select at least one owner");
    }

    if (item.start === '') {
        messages.push("Please select a start date");
    }

    if (item.finish === '') {
        messages.push("Please select a due date");
    }

    if (new Date(item.start) > new Date(item.finish)) {
        messages.push("End date cannot be after start date");
    }
    if (item.objective) {

        let index = objectives.findIndex(x => x.key === item.objective);
        if (new Date(item.finish) > new Date(objectives[index].finish)) {
            messages.push(objectives[index].name + " is due on " + FormatDateUK(objectives[index].finish) + ", please select a date on or before this.");
        }

    }
    if (item.dept === '') {
        messages.push("Please select a department");
    }

    return messages;
}
export const ObjectiveValidation = (item) => {
    let messages = [];

    if (item.name === '') {
        messages.push("Please enter a title");
    }

    if (item.description === '') {
        messages.push("Please enter a description");
    }

    if (item.users.length === 0) {
        messages.push("Please select at least one owner");
    }

    if (item.start === '') {
        messages.push("Please select a start date");
    }

    if (item.finish === '') {
        messages.push("Please select a due date");
    }

    if (new Date(item.start) > new Date(item.finish)) {
        messages.push("End date cannot be after start date");
    }

    return messages;
}
const Validation = (item, deliverables) => {

    let messages = [];

    if (item.name === '') {
        messages.push("Please enter a title");
    }

    if (item.description === '') {
        messages.push("Please enter a description");
    }

    if (item.users.length === 0) {
        messages.push("Please select at least one owner");
    }

    if (item.start === '') {
        messages.push("Please select a start date");
    }

    if (item.finish === '') {
        messages.push("Please select a due date");
    }

    if (new Date(item.start) > new Date(item.finish)) {
        messages.push("End date cannot be after start date");
    }
    if (item.deliverable) {

        let index = deliverables.findIndex(x => x.key === item.deliverable);

        if (new Date(item.finish) > new Date(deliverables[index].finish)) {
            messages.push(deliverables[index].name + " is due on " + FormatDateUK(deliverables[index].finish) + ", please select a date on or before this.");
        }

    }
    if (item.dept === '') {
        messages.push("Please select a department");
    }

    if (item.category === '') {
        messages.push("Please select a work stream");
    }

    return messages;
}

export default Validation;